import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getClientNotificationHistory(clientId) {
  const query = `?recipientType=client&recipientId=${encodeURIComponent(clientId)}`;
  const response = await fetch(`${baseUrl}notifications${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function unsubscribeFromLessonReminders(token) {
  const query = `?token=${encodeURIComponent(token)}`;
  const response = await fetch(`${baseUrl}notifications/lesson-reminders/unsubscribe${query}`, {
    method: "GET",
  });

  if (response.ok) {
    await response.text();
    return { ok: true };
  }

  const error = await response.text();
  throw new Error(error || "Nie można wyłączyć przypomnień z tego linku.");
}

export default {
  getClientNotificationHistory,
  unsubscribeFromLessonReminders,
};
